import React from 'react';

const CustomerCard = ({ customer, onViewDetails, onEdit, onDelete, getStatusColor }) => {
  return (
    <div className="card-hover">
      <div className="p-4">
        <div className="flex justify-between items-center">
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-2">
              <h3 className="text-lg font-semibold text-secondary-900">
                {customer.fullName}
              </h3>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(customer.status)}`}>
                {customer.status}
              </span>
              {customer.propertyType && (
                <span className="px-2 py-1 bg-secondary-100 text-secondary-700 text-xs rounded-full">
                  {customer.propertyType}
                </span>
              )}
            </div>

            <div className="flex flex-wrap items-center gap-4 text-sm">
              <div className="flex items-center space-x-1">
                <svg className="w-4 h-4 text-secondary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-secondary-700">{customer.email}</span>
              </div>
              <div className="flex items-center space-x-1">
                <svg className="w-4 h-4 text-secondary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="text-secondary-700">{customer.phone}</span>
              </div>
              <div className="flex items-center space-x-1">
                <svg className="w-4 h-4 text-secondary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                <span className="text-secondary-700">{customer.totalServices || 0} services</span>
              </div>
              <div className="flex items-center space-x-1">
                <svg className="w-4 h-4 text-secondary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
                <span className="text-secondary-700">${(customer.totalSpent || 0).toLocaleString()}</span>
              </div>
            </div>
          </div>

          <div className="flex space-x-2">
            <button
              onClick={() => onViewDetails(customer)}
              className="text-primary-600 hover:text-primary-700 text-sm font-medium px-3 py-1 rounded hover:bg-primary-50 transition-colors"
            >
              View Details
            </button>
            <button
              onClick={() => onEdit(customer)}
              className="text-secondary-600 hover:text-secondary-700 text-sm font-medium px-3 py-1 rounded hover:bg-secondary-50 transition-colors"
            >
              Edit
            </button>
            <button
              onClick={() => onDelete(customer.id)}
              className="text-red-600 hover:text-red-700 text-sm font-medium px-3 py-1 rounded hover:bg-red-50 transition-colors"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerCard;